import { gql } from '@apollo/client'

const GET_TASKS = gql`
  query getTasks($isCompleted: Boolean) {
    getTasks(isCompleted: $isCompleted) {
      id
      goalId
      title
      isCompleted
      updatedAt
      resourceId
      linkUrl
      linkText
    }
  }
`

export default GET_TASKS
